module.exports = __webpack_public_path__ + "static/media/NoticeofPrivacyPractices.fc40bafb.pdf";